// extracted by mini-css-extract-plugin
module.exports = {"cover_image":"CoverImage_cover_image__2YYJ5","toolbar":"CoverImage_toolbar__1k77P"};